import { Padding } from '@mui/icons-material';
import React from 'react';
import Modal from 'react-modal';

const ModalComp = ({ afterOpenModal, closeModal, children, modalIsOpen, width, padding ,maxHeight}) => {
    const customStyles = {
        content: {
            top: '50%',
            left: '50%',
            right: 'auto',
            bottom: 'auto',
            marginRight: '-50%',
            width: width || '400px', // Set a default width or use the passed prop
            zIndex: '12022',
            transform: 'translate(-50%, -50%)',
            borderRadius: '15px',
            maxHeight: maxHeight ||'80vh',
            maxWidth: '90vw', // Adjust maxWidth to prevent overflow
            overflowY: 'auto', // Vertical scroll
            overflowX: 'hidden', // Hide horizontal scroll
            padding: padding ? padding : '20px',
            border: 'none'
        },
        overlay: {
            backgroundColor: '#00000075', // Transparent background
        },
    };

    Modal.setAppElement('#root');
    return (
        <div>
            <Modal
                isOpen={modalIsOpen}
                onAfterOpen={afterOpenModal}
                onRequestClose={closeModal}
                style={customStyles}
                contentLabel="Example Modal"
            >
                {children}
            </Modal>
        </div>
    );
};

export default ModalComp;
